import "./simplemodal.scss";
import gsap from "gsap";

export class HHDSSimpleModal extends HTMLElement {
  private wrapper!: HTMLDivElement;
  public content: string = "";

  constructor() {
    super();
  }

  connectedCallback() {
    document.body.classList.add("scroll-locked");
    this.render();

    this.wrapper = this.querySelector(".hhds-simple-modal--wrapper__inner") as HTMLDivElement;

    gsap.set(this.wrapper, { opacity: 0, scale: 0.8 });

    requestAnimationFrame(() => {
      this.dispatchEvent(new CustomEvent("modal-opened", { bubbles: true }));
      gsap.to(this.wrapper, { opacity: 1, scale: 1, duration: 0.5, ease: "back.inOut" });
    });
  }

  disconnectedCallback() {
    document.body.classList.remove("scroll-locked");
    this.dispatchEvent(new CustomEvent("modal-closed", { bubbles: true }));
  }

  public populate(content: string) {
    this.content = content;
  }

  private render() {
    this.style.position = "fixed";
    this.style.top = "0";
    this.style.left = "0";
    this.style.width = "100vw";
    this.style.height = "100vh";
    this.style.zIndex = "9999";

    this.innerHTML = `
    <div class="hhds-simple-modal">
      <div class="hhds-simple-modal--backdrop"></div>
      <div class="hhds-simple-modal--wrapper">
        <hhds-button class="hhds-simple-modal--close" type="square" mode="dark" width="default" role="" font-classes="uppercase uppercase--01">
          <hhds-icon type="cross"></hhds-icon>
        </hhds-button>
        <div class="hhds-simple-modal--wrapper__inner">
          ${this.content}</div>
        </div>
      </div>`;

    this.wrapper = this.querySelector(".hhds-simple-modal--wrapper__inner") as HTMLDivElement;

    const html = this.getAttribute("data-html");
    const url = this.getAttribute("data-url");

    if (html) {
      this.wrapper.innerHTML = html;
    } else if (url) {
      const iframe = document.createElement("iframe");
      iframe.src = url;
      iframe.style.boxSizing = "border-box";
      iframe.style.padding = "0 2rem";
      iframe.style.width = "100%";
      iframe.style.height = "80vh";
      iframe.style.border = "none";
      this.wrapper.appendChild(iframe);
    }

    this.querySelector(".hhds-simple-modal--close")?.addEventListener("click", () => {
      this.remove();
    });

    //  Listen for clicks outside the modal to close it
    this.querySelector(".hhds-simple-modal--backdrop")?.addEventListener("click", () => {
      this.remove();
    });

    //  Listen for ESC key to close the modal
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.remove();
      }
    });
  }
}
